import { FormControl, FormLabel, Switch } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreState } from '../../../../models/hooks';

interface QuestionNeedReviewSwitchProps {
  onChange: (value: boolean) => void;
  checked: boolean;
}

export default function QuestionNeedReviewSwitch({ onChange, checked }: QuestionNeedReviewSwitchProps) {
  const { t } = useTranslation('createJobPosition');

  const isNeedReviewEnabled = useStoreState((s) => s.app.accounts?.configuration?.needReviewEnabled);

  if (!isNeedReviewEnabled) return null;
  return (
    <FormControl display="flex" alignItems="center">
      <Switch
        data-testid="need-review-question-switch"
        size="sm"
        id="position-question-need-review"
        onChange={(e) => onChange(e.target.checked)}
        isChecked={checked}
      />
      <FormLabel htmlFor="position-question-need-review" mb="0" ml={2} colorScheme="gray">
        {t('questionNeedReview')}
      </FormLabel>
    </FormControl>
  );
}
